import { RootState } from "@/app/stores";
import { getCommunity, getMainWalletBalance, getMasterWalletBalance, ICommunity } from "@/shared/api/community";
import { ErrorType, IWalletBalance } from "@/shared/types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";

export const fetchCommunityInfo = createAsyncThunk<
    ICommunity,
    void,
    { state: RootState }
>('community/fetchCommunityInfo', async(_, thunkAPI) => {
    try {
        const data = await getCommunity()
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

interface IFetchWalletsResults {
    wallet: IWalletBalance
    masterWallet: number
}

export const fetchWallets = createAsyncThunk<
    IFetchWalletsResults,
    void,
    { state: RootState }
>('community/fetchWallets', async(_, thunkAPI) => {
    try {
        const mainWalletBalance = await getMainWalletBalance()
        const masterWalletBalance = await getMasterWalletBalance()
        return {
            wallet: mainWalletBalance.data,
            masterWallet: masterWalletBalance.data
        }
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})